import {
    UPDATE_CONSIGNMENT_DETAILS_SUCCESS,
    UPDATE_CONSIGNMENT_DETAILS_FAILURE,
    SET_CONSIGNMENT_CU_IN_PROGRESS,
} from '../actions';

import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { removeEmptyFieldsFromObject } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* updateConsignment(action) {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/consignment`;
    delete action.payload.isSubmittedFromSurgeryFlow;
    const payload = removeEmptyFieldsFromObject(action.payload);
    //const isConsignmentOrderSubmitted = action.payload.isSAPSubmission;

    try {
        const result = yield axios
            .post(url, payload)
            .then((response) => response.data);
        // const modify_result = {
        //     ...result,
        //     isSubmitted,
        // };
       // if (result && result.statusCode === '200') {
        yield put({
            type: UPDATE_CONSIGNMENT_DETAILS_SUCCESS,
            data: result,
        });
        // yield put({
        //     type: SET_CONSIGNMENT_ORDER_SUBMITTED,
        //     data: isEquityOrderSubmitted,
        // });
        yield put({ type: SET_CONSIGNMENT_CU_IN_PROGRESS, data: false });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: UPDATE_CONSIGNMENT_DETAILS_FAILURE,
            data: {
                message: errorHandler('422'),
                statusCode: '422',
            },
        });
    }
}
